import { MapPin, Users, Globe } from "lucide-react";
import { Stagger, StaggerItem } from "./Reveal";

export const VISION_PILLARS = [
  {
    icon: MapPin,
    title: "REACH OUR COMMUNITY",
    text: "It starts here - in Lake Asbury, Middleburg, Oakleaf, Fleming Island, Orange Park and across Clay County. We're reaching into our neighborhoods with the love of Jesus, one family at a time.",
  },
  {
    icon: Users,
    title: "MAKE DISCIPLES",
    text: "Our goal is to fulfill the Great Commission - helping real people follow Jesus in real life, not just attend a service.",
  },
  {
    icon: Globe,
    title: "PLANT CHURCHES",
    text: "Victory Chapel is a beginning, not a finish line. We believe healthy churches plant churches - here in Florida and around the world.",
  },
];

export default function VisionPillars() {
  return (
    <Stagger className="mt-10 grid gap-4 sm:mt-12 sm:grid-cols-3 sm:gap-6">
      {VISION_PILLARS.map((p) => (
        <StaggerItem key={p.title}>
          <div
            className="h-full rounded-2xl border border-navy/10 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift sm:rounded-3xl sm:p-8"
            data-testid={`vision-pillar-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          >
            <p.icon size={26} className="text-victory" aria-hidden="true" />
            <h3 className="mt-4 font-display text-lg font-800 tracking-tight text-navy">{p.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">{p.text}</p>
          </div>
        </StaggerItem>
      ))}
    </Stagger>
  );
}
